/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconShoppingCartMinus = createReactComponent("outline", "shopping-cart-minus", "IconShoppingCartMinus", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 17h-6.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

export { IconShoppingCartMinus as default };
//# sourceMappingURL=IconShoppingCartMinus.mjs.map
